import { render, staticRenderFns } from "./file_by_file_navigation.vue?vue&type=template&id=4c434a6f&vue3"
import script from "./file_by_file_navigation.vue?vue&type=script&lang=js&vue3"
export * from "./file_by_file_navigation.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports